<template>
    <div class="scroll" id="messages-box">

        <template v-for="item in sortedMessages">

            <!-- DATE BORDER DIVIDER -->
            <div class="d-flex mt-2 mb-2" v-if="item.date_boundary">

                <div class="align-self-center flex-grow-1 pl-2">
                    <v-divider/>
                </div>

                <div class="align-self-center pl-2 pr-2 caption grey--text">
                    {{ formatDate(item.created_at) }}
                </div>

                <div class="align-self-center flex-grow-1 pr-2">
                    <v-divider/>
                </div>

            </div>

            <!-- CHAT BUBBLE -->
            <chat-bubble
                :key="item.id"
                :message="item.message"
                :user="item.user"
                :created-at="item.created_at"
            ></chat-bubble>

        </template>
    </div>

</template>

<script>

import moment from "moment";
import {timeDisplay} from "../../../components/mixins/timeDisplayMixin";
import ChatBubble from "./ChatBubble";

export default {

    mixins: [timeDisplay],

    components: {
        ChatBubble,
    },

    props: {

        messages: {
            type: Array | null,
            required: true,
        }
    },

    computed: {

        sortedMessages() {
            if (this.messages) {

                let previousDate = moment().subtract(1, 'day');

                return this.messages
                    .slice()
                    .reverse()
                    .map(message => {

                        const createdAt = moment(message.created_at);

                        if (createdAt.isBefore(previousDate)) {
                            message.date_boundary = true;
                        }
                        previousDate = createdAt.subtract(1, 'day');
                        return message;
                    })
            }
        },
    },
}
</script>

<style scoped>

.scroll {
    overflow-y: scroll;
    max-height: 500px;
}

</style>